export default __webpack_public_path__ + "static/media/xoip-logo.68169790.svg";